import { createFileRoute } from '@tanstack/react-router';
import { CommissionDetailRoute } from '@/pages/commissions/detail-route';

/** Deep link al dettaglio: la lista sta già sotto, montata dal layout. */
export const Route = createFileRoute(
  '/referrer/_layout/commissions/_layout/$id'
)({
  component: CommissionDetailRouteComponent,
});

function CommissionDetailRouteComponent() {
  const { id } = Route.useParams();

  return <CommissionDetailRoute commissionId={id} />;
}
